/** Dutch (P-976): every English text the apps pass to `t()`, in Dutch. Keep `{placeholders}` as they are. */
export const nl: Record<string, string> = {
  ' (You)': ' (jij)',
  '## This quarter': '## Dit kwartaal',
  '(at': '(op positie',
  '(edited)': '(bewerkt)',
  '+ Add sort': '+ Sortering toevoegen',
  '+ Set a property': '+ Eigenschap instellen',
  ', a reset link is on its way. Check your inbox.': ', is er een resetlink naar je onderweg. Kijk in je inbox.',
  '.csv → database': '.csv → database',
  '.md, .txt': '.md, .txt',
  '1 day': '1 dag',
  '1 day before (9:00 AM)': '1 dag van tevoren (9:00)',
  '1 hour': '1 uur',
  '1 hour before': '1 uur van tevoren',
  '1 page': '1 pagina',
  '1 person': '1 persoon',
  '12 hour': '12-uurs',
  '24 hour': '24-uurs',
  '30 days': '30 dagen',
  '5 minutes before': '5 minuten van tevoren',
  '7 days': '7 dagen',
  '> Toggle for the details': '> Uitklapblok voor de details',
  '[] Ship the editor': '[] De editor uitbrengen',
  'A block editor and a database in one, synced to every device the moment you type. Your pages live in the cloud on our own servers in Amsterdam — inside the EU, and nowhere else.': 'Een blokeditor en een database in één, gesynchroniseerd met al je apparaten zodra je typt. Je pagina\'s staan in de cloud op onze eigen servers in Amsterdam — binnen de EU, en nergens anders.',
  'A database can have {n} automations': 'Een database kan {n} automatiseringen hebben',
  'A desktop window around the same workspace, with your pages kept on the machine for offline use.': 'Een desktopvenster rond dezelfde werkruimte, met je pagina\'s op de computer bewaard voor offline gebruik.',
  'A short film made from recordings of Lumen: someone starts their own bakery. They write it down in a new page, make a plan with to-dos, break it into steps on a board, a friend joins and writes along live, they tick everything off, and they open on Saturday.': 'Een korte film gemaakt van opnames van Lumen: iemand begint een eigen bakkerij. Het idee komt op een nieuwe pagina, er komt een plan met taken, dat wordt op een bord in stappen opgedeeld, een vriend schuift aan en schrijft live mee, alles wordt afgevinkt en op zaterdag gaat de zaak open.',
  'A simple checklist for the day or week.': 'Een eenvoudige checklist voor de dag of week.',
  'A workspace has its own pages, teamspaces and members.': 'Een werkruimte heeft eigen pagina\'s, teamruimtes en leden.',
  'A workspace needs at least one owner.': 'Een werkruimte heeft minstens één eigenaar nodig.',
  'A workspace that keeps up': 'Een werkruimte die bijblijft',
  'About Lumen': 'Over Lumen',
  'Accept invite': 'Uitnodiging accepteren',
  'Access': 'Toegang',
  'Access requests': 'Toegangsverzoeken',
  'Access to ask for': 'Gevraagde toegang',
  'access. Only people with full access can change sharing.': '— alleen mensen met volledige toegang kunnen het delen wijzigen.',
  'Account': 'Account',
  'Acme HQ': 'Acme HQ',
  'Acme Inc.': 'Acme B.V.',
  'Acme Labs': 'Acme Labs',
  'Actions': 'Acties',
  'Active': 'Actief',
  'Activity': 'Activiteiten',
  'Actual Size': 'Werkelijke grootte',
  'Ada': 'Ada',
  'Add': 'Toevoegen',
  'Add a block': 'Blok toevoegen',
  'Add a board database as a sub-page.': 'Voeg een borddatabase toe als subpagina.',
  'Add a calendar database as a sub-page.': 'Voeg een kalenderdatabase toe als subpagina.',
  'Add a comment…': 'Voeg een opmerking toe…',
  'Add a gallery database as a sub-page.': 'Voeg een galerijdatabase toe als subpagina.',
  'Add a list database as a sub-page.': 'Voeg een lijstdatabase toe als subpagina.',
  'Add a page': 'Pagina toevoegen',
  'Add a page inside': 'Subpagina toevoegen',
  'Add a property': 'Eigenschap toevoegen',
  'Add a row to preview the result': 'Voeg een rij toe om een voorbeeld van het resultaat te zien',
  'Add a simple table to this page.': 'Voeg een eenvoudige tabel toe aan deze pagina.',
  'Add a sub-item': 'Subitem toevoegen',
  'Add a table database as a sub-page.': 'Voeg een tabeldatabase toe als subpagina.',
  'Add a TeX equation': 'TeX-vergelijking toevoegen',
  'Add a timeline database as a sub-page.': 'Voeg een tijdlijndatabase toe als subpagina.',
  'Add action': 'Actie toevoegen',
  'Add advanced filter': 'Geavanceerd filter toevoegen',
  'Add an inline board database.': 'Voeg een inline borddatabase toe.',
  'Add an inline calendar database.': 'Voeg een inline kalenderdatabase toe.',
  'Add an inline gallery database.': 'Voeg een inline galerijdatabase toe.',
  'Add an inline list database.': 'Voeg een inline lijstdatabase toe.',
  'Add an inline table database.': 'Voeg een inline tabeldatabase toe.',
  'Add an inline timeline database.': 'Voeg een inline tijdlijndatabase toe.',
  'Add an option': 'Optie toevoegen',
  'Add column': 'Kolom toevoegen',
  'Add comment': 'Opmerking toevoegen',
  'Add cover': 'Omslag toevoegen',
  'Add filter': 'Filter toevoegen',
  'Add filter group': 'Filtergroep toevoegen',
  'Add filter rule': 'Filterregel toevoegen',
  'Add header': 'Header toevoegen',
  'Add headings to create a table of contents.': 'Voeg koppen toe om een inhoudsopgave te maken.',
  'Add icon': 'Pictogram toevoegen',
  'Add page to': 'Pagina toevoegen aan',
  'Add page to {p0}': 'Pagina toevoegen aan {p0}',
  'Add people by email': 'Personen toevoegen via e-mail',
  'Add people, emails, groups': 'Personen, e-mailadressen of groepen toevoegen',
  'Add reaction': 'Reactie toevoegen',
  'Add row': 'Rij toevoegen',
  'Add rule': 'Regel toevoegen',
  'Add to Favorites': 'Toevoegen aan favorieten',
  'Add trigger': 'Trigger toevoegen',
  'Add view': 'Weergave toevoegen',
  'Advanced blocks': 'Geavanceerde blokken',
  'Agenda, notes and action items for a meeting.': 'Agenda, notities en actiepunten voor een vergadering.',
  'All rows and properties': 'Alle rijen en eigenschappen',
  'Allow': 'Toestaan',
  'Allow comments': 'Opmerkingen toestaan',
  'Allow duplicate as template': 'Dupliceren als sjabloon toestaan',
  'Allow editing': 'Bewerken toestaan',
  'Allowed': 'Toegestaan',
  'Alphabetical': 'Alfabetisch',
  'Already have an account? ': 'Heb je al een account? ',
  'Amsterdam, EU region': 'Amsterdam, EU-regio',
  'An account with this email already exists.': 'Er bestaat al een account met dit e-mailadres.',
  'An automation ran': 'Er is een automatisering uitgevoerd',
  'An email address and a password. You get a workspace with a Getting Started page already in it.': 'Een e-mailadres en een wachtwoord. Je krijgt een werkruimte waarin de pagina Aan de slag al klaarstaat.',
  'And': 'En',
  'And also': 'En verder',
  'Anyone in {name}': 'Iedereen in {name}',
  'Anyone with this link can join this workspace as a member.': 'Iedereen met deze link kan lid worden van deze werkruimte.',
  'Appearance': 'Weergave',
  'Archive': 'Archiveren',
  'Archive all': 'Alles archiveren',
  'Archive teamspace': 'Teamruimte archiveren',
  'Archived': 'Gearchiveerd',
  'Are you sure you want to delete this page from Trash? This cannot be undone.': 'Weet je zeker dat je deze pagina uit de prullenbak wilt verwijderen? Dit kan niet ongedaan worden gemaakt.',
  'Are you sure?': 'Weet je het zeker?',
  'Ascending': 'Oplopend',
  'Ask someone with full access to share it with you.': 'Vraag iemand met volledige toegang om de pagina met je te delen.',
  'Assignments': 'Toewijzingen',
  'At': 'Om',
  'At a glance': 'In één oogopslag',
  'At least 8 characters': 'Minstens 8 tekens',
  'At time of event': 'Op het moment zelf',
  'Audio': 'Audio',
  'Australian dollar': 'Australische dollar',
  'Automation': 'Automatisering',
  'Automation in {title}': 'Automatisering in {title}',
  'Automation: {title}': 'Automatisering: {title}',
  'Automations': 'Automatiseringen',
  'Automations · {p0}': 'Automatiseringen · {p0}',
  'Available now, on every platform, and it keeps working when the connection drops.': 'Nu beschikbaar, op elk platform, en hij blijft werken als de verbinding wegvalt.',
  'Available offline': 'Offline beschikbaar',
  'Average': 'Gemiddelde',
  'Back': 'Terug',
  'Back to log in': 'Terug naar inloggen',
  'Back to my content': 'Terug naar mijn inhoud',
  'Background': 'Achtergrond',
  'Backlinks': 'Backlinks',
  'backlinks)': 'backlinks)',
  'Bar': 'Balk',
  'Basic blocks': 'Basisblokken',
  'Best matches': 'Beste resultaten',
  'Bi-week': 'Twee weken',
  'Big section heading.': 'Grote sectiekop.',
  'Block equation': 'Blokvergelijking',
  'Blocked by': 'Geblokkeerd door',
  'Blocking': 'Blokkeert',
  'Blue': 'Blauw',
  'Board': 'Bord',
  'Board - Full page': 'Bord - volledige pagina',
  'Board view': 'Bordweergave',
  'Bold': 'Vet',
  'Bookmarks and embeds': 'Bladwijzers en ingesloten inhoud',
  'Breadcrumb': 'Kruimelpad',
  'Bring All to Front': 'Alles op voorgrond',
  'Bring people in': 'Haal mensen erbij',
  'Brown': 'Bruin',
  'Bulleted list': 'Opsommingslijst',
  'Button': 'Knop',
  'Button not working? Paste this link into your browser:': 'Werkt de knop niet? Plak deze link in je browser:',
  'Buttons': 'Knoppen',
  'Calculate': 'Berekenen',
  'Calendar': 'Kalender',
  'Calendar - Full page': 'Kalender - volledige pagina',
  'Calendar view': 'Kalenderweergave',
  'Callout': 'Kader',
  'Callouts and quotes': 'Kaders en citaten',
  'Can comment': 'Kan opmerkingen plaatsen',
  'Can edit': 'Kan bewerken',
  'Can edit content': 'Kan inhoud bewerken',
  'Can view': 'Kan bekijken',
  'Can\'t move a page inside itself': 'Je kunt een pagina niet in zichzelf verplaatsen',
  'Canadian dollar': 'Canadese dollar',
  'Cancel': 'Annuleren',
  'Caption': 'Bijschrift',
  'Capture a code snippet.': 'Leg een codefragment vast.',
  'Capture a quote.': 'Leg een citaat vast.',
  'Card preview': 'Kaartvoorbeeld',
  'Card size': 'Kaartgrootte',
  'Center': 'Centrering',
  'Center peek': 'Venster in het midden',
  'Change cover': 'Omslag wijzigen',
  'Change email': 'E-mailadres wijzigen',
  'Change icon': 'Pictogram wijzigen',
  'Change password': 'Wachtwoord wijzigen',
  'Change the language used in the user interface.': 'Wijzig de taal van de gebruikersinterface.',
  'Change type': 'Type wijzigen',
  'Changes since': 'Wijzigingen sinds',
  'Chart': 'Grafiek',
  'Chart type': 'Grafiektype',
  'Check for Updates…': 'Zoeken naar updates…',
  'Checkbox': 'Selectievakje',
  'Checked': 'Aangevinkt',
  'Choose a database': 'Kies een database',
  'Choose a new password': 'Kies een nieuw wachtwoord',
  'Choose a new password for your Lumen account.': 'Kies een nieuw wachtwoord voor je Lumen-account.',
  'Choose a page': 'Kies een pagina',
  'Choose a property to group by in the view settings.': 'Kies in de weergave-instellingen een eigenschap om op te groeperen.',
  'Choose a range': 'Kies een bereik',
  'Choose an action…': 'Kies een actie…',
  'Choose what to show when Lumen starts or when you switch workspaces.': 'Kies wat je ziet als Lumen start of als je van werkruimte wisselt.',
  'Choose…': 'Kies…',
  'Claude Code': 'Claude Code',
  'Claude Desktop (claude_desktop_config.json)': 'Claude Desktop (claude_desktop_config.json)',
  'Clear': 'Wissen',
  'Clear filter': 'Filter wissen',
  'Clear search': 'Zoekopdracht wissen',
  'Clear selection': 'Selectie wissen',
  'Click to add below. Alt-click to add a block above': 'Klik om hieronder toe te voegen. Alt-klik om erboven een blok toe te voegen',
  'Close': 'Sluiten',
  'Close find': 'Zoeken sluiten',
  'Close Other Tabs': 'Andere tabbladen sluiten',
  'Close settings': 'Instellingen sluiten',
  'Close sidebar': 'Zijbalk sluiten',
  'Close Tab': 'Tabblad sluiten',
  'Close tab': 'Tabblad sluiten',
  'Close Window': 'Venster sluiten',
  'Closed': 'Gesloten',
  'Closed: anyone can see members, only members can see pages': 'Gesloten: iedereen ziet de leden, alleen leden zien de pagina\'s',
  'Clusters': 'Clusters',
  'Code': 'Code',
  'Code - Mermaid': 'Code - Mermaid',
  'Code with syntax highlighting': 'Code met syntaxiskleuring',
  'Collapse': 'Samenvouwen',
  'Collapse group': 'Groep samenvouwen',
  'Collect feedback from the beta group': 'Feedback van de bètagroep verzamelen',
  'Color': 'Kleur',
  'Color & Gradient': 'Kleur & verloop',
  'Color rows or cells when their values match a rule.': 'Kleur rijen of cellen wanneer hun waarden aan een regel voldoen.',
  'Column options': 'Kolomopties',
  'Columns and synced blocks': 'Kolommen en gesynchroniseerde blokken',
  'Comment': 'Opmerking plaatsen',
  'Comment deleted': 'Opmerking verwijderd',
  'Comment on this block.': 'Plaats een opmerking bij dit blok.',
  'Comments': 'Opmerkingen',
  'Complete': 'Voltooid',
  'Condition': 'Voorwaarde',
  'Conditional color': 'Voorwaardelijke kleur',
  'Confirm email': 'E-mailadres bevestigen',
  'Confirm your email address': 'Bevestig je e-mailadres',
  'Contains': 'Bevat',
  'Content to insert (Markdown)': 'In te voegen inhoud (Markdown)',
  'Continue': 'Doorgaan',
  'Continue to Lumen': 'Doorgaan naar Lumen',
  'Copied link to block': 'Link naar blok gekopieerd',
  'Copied link to clipboard': 'Link naar klembord gekopieerd',
  'Copied link to view': 'Link naar weergave gekopieerd',
  'Copied synced block. Paste it anywhere to keep it in sync': 'Gesynchroniseerd blok gekopieerd. Plak het waar je wilt om het gesynchroniseerd te houden',
  'Copied to clipboard': 'Naar klembord gekopieerd',
  'Copy': 'Kopiëren',
  'Copy and sync': 'Kopiëren en synchroniseren',
  'Copy Link': 'Link kopiëren',
  'Copy link': 'Link kopiëren',
  'Copy link to block': 'Link naar blok kopiëren',
  'Copy Link to Page': 'Link naar pagina kopiëren',
  'Copy link to view': 'Link naar weergave kopiëren',
  'Copy your token now.': 'Kopieer je token nu.',
  'Could not answer the request.': 'Het verzoek kon niet worden beantwoord.',
  'Could not verify': 'Bevestigen is niet gelukt',
  'Couldn\'t check for updates': 'Kan niet zoeken naar updates',
  'Count': 'Aantal',
  'Count all': 'Alles tellen',
  'Count empty': 'Lege tellen',
  'Count not empty': 'Niet-lege tellen',
  'Count unique values': 'Unieke waarden tellen',
  'Count values': 'Waarden tellen',
  'Cover removed': 'Omslag verwijderd',
  'Create': 'Maken',
  'Create a link people can use to join this workspace.': 'Maak een link waarmee mensen lid kunnen worden van deze werkruimte.',
  'Create a list with numbering.': 'Maak een lijst met nummering.',
  'Create a new teamspace': 'Nieuwe teamruimte maken',
  'Create a public site from this page. Anyone with the link can view it, without signing in.': 'Maak een openbare site van deze pagina. Iedereen met de link kan hem bekijken, zonder in te loggen.',
  'Create a simple bulleted list.': 'Maak een eenvoudige opsommingslijst.',
  'Create a teamspace': 'Teamruimte maken',
  'Create a workspace': 'Een werkruimte aanmaken',
  'Create an account': 'Account aanmaken',
  'Create bookmark': 'Bladwijzer maken',
  'Create diagrams with Mermaid.': 'Maak diagrammen met Mermaid.',
  'Create embed': 'Insluiting maken',
  'Create equation': 'Vergelijking maken',
  'Create link': 'Link maken',
  'Create teamspace': 'Teamruimte maken',
  'Create token': 'Token aanmaken',
  'Create workspace': 'Werkruimte aanmaken',
  'Create your account': 'Maak je account aan',
  'Create your account with {email} to get access.': 'Maak je account aan met {email} om toegang te krijgen.',
  'Create {n} columns of blocks.': 'Maak {n} kolommen met blokken.',
  'Created': 'Aangemaakt',
  'Created by': 'Gemaakt door',
  'Created by: {p0}': 'Aangemaakt door: {p0}',
  'Created time': 'Aangemaakt op',
  'Created: newest first': 'Aangemaakt: nieuwste eerst',
  'Created: oldest first': 'Aangemaakt: oudste eerst',
  'CSV': 'CSV',
  'Current password': 'Huidig wachtwoord',
  'Current view (its filters, sorts and visible properties)': 'Huidige weergave (met de filters, sorteringen en zichtbare eigenschappen)',
  'Cursor, Codex, Gemini CLI, VS Code (mcp.json)': 'Cursor, Codex, Gemini CLI, VS Code (mcp.json)',
  'Customize how Lumen looks on this device.': 'Pas aan hoe Lumen eruitziet op dit apparaat.',
  'Customize page': 'Pagina aanpassen',
  'Cut': 'Knippen',
  'Daily': 'Dagelijks',
  'Dark': 'Donker',
  'Database': 'Database',
  'Database options': 'Databaseopties',
  'Database rows': 'Databaserijen',
  'Database templates and buttons': 'Databasesjablonen en knoppen',
  'Databases only': 'Alleen databases',
  'Date': 'Datum',
  'Date by': 'Datums per',
  'Date format': 'Datumnotatie',
  'Date or reminder': 'Datum of herinnering',
  'Date range': 'Datumbereik',
  'Dates': 'Datums',
  'Day': 'Dag',
  'Day/Month/Year': 'Dag/maand/jaar',
  'Decide on the offline story': 'Besluiten over de offline-aanpak',
  'Decimal places': 'Decimalen',
  'Default': 'Standaard',
  'Default access': 'Standaardtoegang',
  'Default background': 'Standaardachtergrond',
  'Default template set for all views': 'Standaardsjabloon ingesteld voor alle weergaven',
  'Default text': 'Standaardtekst',
  'Del': 'Del',
  'Delete': 'Verwijderen',
  'Delete automation': 'Automatisering verwijderen',
  'Delete column': 'Kolom verwijderen',
  'Delete comment': 'Opmerking verwijderen',
  'Delete entire workspace': 'Hele werkruimte verwijderen',
  'Delete filter': 'Filter verwijderen',
  'Delete from Trash': 'Uit prullenbak verwijderen',
  'Delete group': 'Groep verwijderen',
  'Delete my account': 'Mijn account verwijderen',
  'Delete option': 'Optie verwijderen',
  'Delete permanently': 'Definitief verwijderen',
  'Delete property': 'Eigenschap verwijderen',
  'Delete row': 'Rij verwijderen',
  'Delete rule': 'Regel verwijderen',
  'Delete sort': 'Sorteringen verwijderen',
  'Delete the current block.': 'Verwijder het huidige blok.',
  'Delete view': 'Weergave verwijderen',
  'Delete, duplicate, and more…': 'Verwijderen, dupliceren en meer…',
  'Deleted page': 'Verwijderde pagina',
  'Deleted property': 'Verwijderde eigenschap',
  'Deleting a workspace removes all its pages for everyone. This cannot be undone.': 'Als je een werkruimte verwijdert, verdwijnen alle pagina\'s erin voor iedereen. Dit kan niet ongedaan worden gemaakt.',
  'Denied': 'Geweigerd',
  'Deny': 'Weigeren',
  'Dependencies': 'Afhankelijkheden',
  'Depth': 'Diepte',
  'Descending': 'Aflopend',
  'Description': 'Beschrijving',
  'Devices': 'Apparaten',
  'Dismiss': 'Negeren',
  'Display': 'Uiterlijk',
  'Display a standalone math equation.': 'Toon een losse wiskundige vergelijking.',
  'Divide by': 'Delen door',
  'Divider': 'Scheidingslijn',
  'Do': 'Dan',
  'Docs, notes and databases. Hosted in the EU.': 'Documenten, notities en databases. Gehost in de EU.',
  'Does not contain': 'Bevat niet',
  'Domain': 'Domein',
  'Domain updated': 'Domein bijgewerkt',
  'Done': 'Klaar',
  'Done ↵': 'Klaar ↵',
  'Donut': 'Donut',
  'Download': 'Downloaden',
  'Download for Mac': 'Downloaden voor Mac',
  'Downloaded': 'Gedownload',
  'Downloading Lumen {version}': 'Lumen {version} downloaden',
  'Drag image to reposition': 'Sleep de afbeelding om de positie te wijzigen',
  'Drag to a task that waits for this one': 'Sleep naar een taak die op deze wacht',
  'Drag to move. Click to open menu': 'Sleep om te verplaatsen. Klik om het menu te openen',
  'Drag to reorder': 'Slepen om te ordenen',
  'Duplicate': 'Dupliceren',
  'Duplicate property': 'Eigenschap dupliceren',
  'Duplicate Tab': 'Tabblad dupliceren',
  'Duplicate the current block.': 'Dupliceer het huidige blok.',
  'Duplicate view': 'Weergave dupliceren',
  'Duplicated database': 'Database gedupliceerd',
  'E = mc^2': 'E = mc^2',
  'Earliest date': 'Vroegste datum',
  'Edit': 'Bewerken',
  'Edit automation': 'Automatisering bewerken',
  'Edit button': 'Knop bewerken',
  'Edit comment': 'Opmerking bewerken',
  'Edit formula': 'Formule bewerken',
  'Edit link': 'Link bewerken',
  'Edit pages in': 'Pagina\'s bewerken in',
  'Edit pages in {p0}': 'Pagina\'s bewerken in {p0}',
  'Edit property': 'Eigenschap bewerken',
  'Edit view': 'Weergave bewerken',
  'Edited just now': 'Zojuist bewerkt',
  'edited this page': 'heeft deze pagina bewerkt',
  'Edited {when}': 'Bewerkt: {when}',
  'Editing': 'Bewerken',
  'Editing in {n} other page': 'Wordt ook bewerkt op {n} andere pagina',
  'Editing in {n} other pages': 'Wordt ook bewerkt op {n} andere pagina\'s',
  'Edits reach every device in real time. Lose the connection and you keep typing; it catches up by itself when you are back.': 'Wijzigingen bereiken elk apparaat in realtime. Valt de verbinding weg, dan typ je gewoon door; zodra je terug bent, haalt alles zichzelf in.',
  'Email': 'E-mailadres',
  'Email changed': 'E-mailadres gewijzigd',
  'Email is not set up on this server.': 'E-mail is op deze server niet ingesteld.',
  'Email notifications': 'E-mailmeldingen',
  'Email verified': 'E-mailadres bevestigd',
  'Embed': 'Insluiten',
  'Embed a PDF': 'PDF insluiten',
  'Embed a PDF document.': 'Sluit een PDF-document in.',
  'Embed a sub-page inside this page.': 'Voeg een subpagina toe binnen deze pagina.',
  'Embed a website, video, design or map.': 'Sluit een website, video, ontwerp of kaart in.',
  'Embed audio or upload a recording.': 'Sluit audio in of upload een opname.',
  'Embed from YouTube, Vimeo or upload.': 'Sluit in vanaf YouTube of Vimeo, of upload.',
  'Embed link': 'Link insluiten',
  'Embedded content': 'Ingesloten inhoud',
  'Embeds': 'Insluitingen',
  'Emoji': 'Emoji',
  'Empty': 'Leeg',
  'Empty page': 'Lege pagina',
  'Empty toggle. Click or drop blocks inside.': 'Leeg uitklapblok. Klik of sleep blokken hierin.',
  'End date': 'Einddatum',
  'End presentation': 'Presentatie beëindigen',
  'Ends with': 'Eindigt op',
  'Enter the webhook address again': 'Vul het webhookadres opnieuw in',
  'Enter your email address…': 'Vul je e-mailadres in…',
  'Enter your name': 'Vul je naam in',
  'Enter your password to confirm.': 'Voer je wachtwoord in om te bevestigen.',
  'Enter your password…': 'Vul je wachtwoord in…',
  'EU hosting': 'EU-hosting',
  'Euro': 'Euro',
  'Every': 'Elke',
  'Every block, one keystroke away.': 'Elk blok op één toetsaanslag afstand.',
  'Every day': 'Elke dag',
  'Every month': 'Elke maand',
  'every page': 'elke pagina',
  'Every page you can see, as Markdown with databases as CSV, in a .zip.': 'Elke pagina die je kunt zien, als Markdown met databases als CSV, in een .zip.',
  'Every panel below is a thing Lumen does today, with an automated test behind it. No waiting list, no “coming soon”.': 'Elk paneel hieronder is iets wat Lumen vandaag al doet, met een geautomatiseerde test erachter. Geen wachtlijst, geen “binnenkort”.',
  'Every week': 'Elke week',
  'Everyone agrees': 'Iedereen is het eens',
  'Everything here syncs live. Try it with a second browser window.': 'Alles hier synchroniseert live. Probeer het met een tweede browservenster.',
  'Exact date': 'Exacte datum',
  'Expand': 'Uitvouwen',
  'Expand group': 'Groep uitvouwen',
  'Expanded': 'Uitgevouwen',
  'Export': 'Exporteren',
  'Export a page or the whole workspace as Markdown, HTML, CSV, PDF or a .zip, whenever you want.': 'Exporteer een pagina of de hele werkruimte als Markdown, HTML, CSV, PDF of .zip, wanneer je maar wilt.',
  'Export all workspace content': 'Alle inhoud van de werkruimte exporteren',
  'Export anything, any time': 'Exporteer alles, wanneer je wilt',
  'Export as CSV': 'Exporteren als CSV',
  'Export as Markdown & CSV (.zip)': 'Exporteren als Markdown & CSV (.zip)',
  'Export complete': 'Export voltooid',
  'Export format': 'Exportformaat',
  'Export Markdown, HTML, CSV, PDF': 'Export naar Markdown, HTML, CSV, PDF',
  'Export…': 'Exporteren…',
  'Favorite': 'Favoriet',
  'Favorites': 'Favorieten',
  'Features': 'Functies',
  'File': 'Bestand',
  'Files & media': 'Bestanden en media',
  'Filter': 'Filteren',
  'Filter by…': 'Filteren op…',
  'Filters': 'Filters',
  'Filter…': 'Filteren…',
  'Find anything': 'Vind alles',
  'Find in page': 'Zoeken op pagina',
  'Find…': 'Zoeken…',
  'Fit image': 'Afbeelding passend maken',
  'Fit to screen': 'Passend maken',
  'Flags': 'Vlaggen',
  'Following': 'Volgen',
  'Footer': 'Voettekst',
  'Forbidden': 'Geen toegang',
  'Forces': 'Krachten',
  'Forgot password?': 'Wachtwoord vergeten?',
  'Formula': 'Formule',
  'Forward': 'Vooruit',
  'Fr': 'vr',
  'Franc': 'Frank',
  'Free to start, no credit card. Nothing to install: open a browser and pick up where you left off.': 'Gratis om te beginnen, geen creditcard nodig. Niets te installeren: open een browser en ga verder waar je gebleven was.',
  'Freeze up to column': 'Vastzetten tot en met deze kolom',
  'Fri': 'vr',
  'Friday': 'vrijdag',
  'Full access': 'Volledige toegang',
  'Full date': 'Volledige datum',
  'Full page': 'Volledige pagina',
  'Full screen': 'Volledig scherm',
  'Full width': 'Volledige breedte',
  'Full, edit, comment or view access per page, guests by email, and publishing that you turn on yourself.': 'Per pagina volledige toegang of toegang om te bewerken, opmerkingen te plaatsen of te bekijken, gasten via e-mail, en publiceren dat je zelf aanzet.',
  'Functions': 'Functies',
  'Galaxy': 'Sterrenstelsel',
  'Gallery': 'Galerij',
  'Gallery - Full page': 'Galerij - volledige pagina',
  'Gallery view': 'Galerijweergave',
  'General access': 'Algemene toegang',
  'Go to Parent Page': 'Naar bovenliggende pagina',
  'Goals and a board of tasks by status.': 'Doelen en een bord met taken per status.',
  'Good afternoon': 'Goedemiddag',
  'Good evening': 'Goedenavond',
  'Good morning': 'Goedemorgen',
  'Grace': 'Grace',
  'Graph': 'Netwerk',
  'Gray': 'Grijs',
  'Green': 'Groen',
  'Group': 'Groeperen',
  'Group by': 'Groeperen op',
  'Group dates by': 'Datums groeperen per',
  'Group order': 'Groepsvolgorde',
  'Group this board by a select, status or other property in view settings.': 'Groepeer dit bord in de weergave-instellingen op een selectie, status of andere eigenschap.',
  'Groups': 'Groepen',
  'Guest': 'Gast',
  'Half a minute of the real thing': 'Een halve minuut van de echte app',
  'Header': 'Header',
  'Header column': 'Kopkolom',
  'Header row': 'Koprij',
  'Heading': 'Kop',
  'Heading 1': 'Kop 1',
  'Heading 2': 'Kop 2',
  'Heading 3': 'Kop 3',
  'Help': 'Help',
  'Hi {name},': 'Hoi {name},',
  'Hidden groups': 'Verborgen groepen',
  'Hide': 'Verbergen',
  'Hide all': 'Alles verbergen',
  'Hide content inside a large heading.': 'Verberg inhoud onder een grote kop.',
  'Hide content inside a medium heading.': 'Verberg inhoud onder een middelgrote kop.',
  'Hide content inside a small heading.': 'Verberg inhoud onder een kleine kop.',
  'Hide empty groups': 'Lege groepen verbergen',
  'Hide empty properties': 'Lege eigenschappen verbergen',
  'Hide filters': 'Filters verbergen',
  'Hide in view': 'Verbergen in weergave',
  'Hide Lumen': 'Lumen verbergen',
  'Hide Others': 'Andere verbergen',
  'Hide sub-items': 'Subitems verbergen',
  'Hide table': 'Tabel verbergen',
  'Hide {label}': '{label} verbergen',
  'Hide {name}': '{name} verbergen',
  'Highest first': 'Hoogste eerst',
  'History': 'Geschiedenis',
  'Home': 'Start',
  'Hosting': 'Hosting',
  'Hours': 'Uren',
  'Hover a function to see how it works.': 'Wijs een functie aan om te zien hoe die werkt.',
  'How it works': 'Zo werkt het',
  'HTML': 'HTML',
  'https://…': 'https://…',
  'Icon': 'Pictogram',
  'Icon & name': 'Pictogram & naam',
  'Icon updated': 'Pictogram bijgewerkt',
  'Icons': 'Pictogrammen',
  'ID': 'ID',
  'If an account exists for': 'Als er een account bestaat voor',
  'If this was not you, ignore this email: your password stays the same.': 'Was jij dit niet? Negeer deze e-mail dan: je wachtwoord blijft hetzelfde.',
  'If you did not create a Lumen account, you can ignore this email.': 'Heb je geen Lumen-account aangemaakt? Dan kun je deze e-mail negeren.',
  'If you were not expecting this invitation, you can ignore this email.': 'Verwachtte je deze uitnodiging niet? Dan kun je deze e-mail negeren.',
  'Image': 'Afbeelding',
  'Images wider than 1500 pixels work best.': 'Afbeeldingen breder dan 1500 pixels werken het best.',
  'Import': 'Importeren',
  'Import failed: {message}': 'Importeren mislukt: {message}',
  'Import Markdown, HTML, CSV, .zip': 'Import van Markdown, HTML, CSV, .zip',
  'Import pages from Markdown, HTML, CSV or a Markdown & CSV archive.': 'Importeer pagina\'s uit Markdown, HTML, CSV of een Markdown & CSV-archief.',
  'Imported {name}': '{name} geïmporteerd',
  'Imported {pages}, {databases} and {files} from Notion': '{pages}, {databases} en {files} geïmporteerd uit Notion',
  'Import…': 'Importeren…',
  'In': 'In',
  'In progress': 'Bezig',
  'In: {p0}': 'In: {p0}',
  'Inbox': 'Inbox',
  'Include subpages': 'Subpagina\'s opnemen',
  'Include time': 'Tijd toevoegen',
  'Incorrect email or password.': 'Onjuist e-mailadres of wachtwoord.',
  'Indent': 'Inspringen',
  'Inline': 'Inline',
  'Inline and page comments': 'Opmerkingen in de tekst en op de pagina',
  'Inline equation': 'Inline vergelijking',
  'Insert a date or set a reminder.': 'Voeg een datum in of stel een herinnering in.',
  'Insert a mathematical symbol in text.': 'Voeg een wiskundig symbool in tekst in.',
  'Insert above': 'Erboven invoegen',
  'Insert below': 'Eronder invoegen',
  'Insert blocks': 'Blokken invoegen',
  'Insert blocks, add or edit pages, or open a page with one click.': 'Voeg blokken in, maak of bewerk pagina\'s, of open een pagina met één klik.',
  'Insert left': 'Links invoegen',
  'Insert right': 'Rechts invoegen',
  'Insert the current date and time.': 'Voeg de huidige datum en tijd in.',
  'Invalid diagram': 'Ongeldig diagram',
  'Invalid equation': 'Ongeldige vergelijking',
  'Invalid JSON': 'Ongeldige JSON',
  'Invalid URL': 'Ongeldige URL',
  'Invite': 'Uitnodigen',
  'Invite link': 'Uitnodigingslink',
  'Invite link not valid': 'Uitnodigingslink is ongeldig',
  'Invite per page with full, edit, comment or view access — or publish a read-only link. Everything you do not share stays yours.': 'Nodig mensen per pagina uit met volledige toegang of toegang om te bewerken, opmerkingen te plaatsen of te bekijken — of publiceer een link die alleen te lezen is. Alles wat je niet deelt, blijft van jou.',
  'Invited · waiting for sign-up': 'Uitgenodigd · nog geen account aangemaakt',
  'Invites': 'Uitnodigingen',
  'iOS': 'iOS',
  'iOS — coming soon': 'iOS — binnenkort',
  'Is': 'Is',
  'Is after': 'Is na',
  'Is before': 'Is vóór',
  'Is empty': 'Is leeg',
  'Is not': 'Is niet',
  'Is not empty': 'Is niet leeg',
  'Is on or after': 'Is op of na',
  'Is on or before': 'Is op of vóór',
  'Is within': 'Valt binnen',
  'It hasn\'t run yet.': 'Deze is nog niet uitgevoerd.',
  'It is shown only once.': 'Het wordt maar één keer getoond.',
  'It may have been deleted, or you may not have access to it.': 'Misschien is hij verwijderd, of heb je er geen toegang toe.',
  'Italic': 'Cursief',
  'Italicize': 'Cursief',
  'Join': 'Lid worden',
  'Join workspace': 'Deelnemen aan werkruimte',
  'Join {inviter} on Lumen.': 'Werk samen met {inviter} in Lumen.',
  'Join {name}': 'Deelnemen aan {name}',
  'Just now': 'Zojuist',
  'Just start writing with plain text.': 'Begin gewoon te schrijven in platte tekst.',
  'Keep as link': 'Als link houden',
  'Keeps working offline': 'Werkt ook offline',
  'Keyboard Shortcuts': 'Sneltoetsen',
  'Krona': 'Kroon',
  'Label': 'Label',
  'Labels': 'Labels',
  'Language': 'Taal',
  'Language & region': 'Taal & regio',
  'Large': 'Groot',
  'Last 30 days': 'Afgelopen 30 dagen',
  'Last 7 days': 'Afgelopen 7 dagen',
  'Last edited': 'Laatst bewerkt',
  'Last edited by': 'Laatst bewerkt door',
  'Last edited by: {p0}': 'Laatst bewerkt door: {p0}',
  'Last edited time': 'Laatst bewerkt op',
  'Last edited: newest first': 'Laatst bewerkt: nieuwste eerst',
  'Last edited: oldest first': 'Laatst bewerkt: oudste eerst',
  'Last used': 'Laatst gebruikt',
  'Last used {date}': 'Laatst gebruikt op {date}',
  'last used {p0}': 'laatst gebruikt {p0}',
  'Last visited page': 'Laatst bezochte pagina',
  'Later': 'Later',
  'Latest date': 'Laatste datum',
  'Layout': 'Indeling',
  'Learn Spelling': 'Spelling leren',
  'Leave': 'Verlaat',
  'Leave teamspace': 'Teamruimte verlaten',
  'Leave workspace': 'Werkruimte verlaten',
  'Let AI assistants such as Claude, ChatGPT and Gemini, and their command-line tools, work in Lumen through MCP: pages, databases and their views, automations, teamspaces, sharing, comments, versions and more. Create a token per app: it can do everything you can do in Lumen, and you can revoke it at any time.': 'Laat AI-assistenten zoals Claude, ChatGPT en Gemini, en hun command-line-tools, via MCP in Lumen werken: pagina\'s, databases en hun weergaven, automatiseringen, teamruimtes, delen, opmerkingen, versies en meer. Maak per app een token aan: het kan alles wat jij in Lumen kunt, en je kunt het op elk moment intrekken.',
  'Light': 'Licht',
  'Limit': 'Limiet',
  'Line': 'Lijn',
  'Link': 'Link',
  'Link copied': 'Link gekopieerd',
  'Link distance': 'Linkafstand',
  'Link expires': 'Link verloopt',
  'Link it to the page': 'Koppelen aan de pagina',
  'Link or create a page…': 'Koppel of maak een pagina…',
  'Link to a page inline.': 'Link inline naar een pagina.',
  'Link to an existing page.': 'Link naar een bestaande pagina.',
  'Link to page': 'Link naar pagina',
  'Linked view of database': 'Gekoppelde weergave van database',
  'links,': 'links,',
  'List': 'Lijst',
  'List - Full page': 'Lijst - volledige pagina',
  'List view': 'Lijstweergave',
  'Live at lumen.jeanluc.online': 'Live op lumen.jeanluc.online',
  'Live cursors, presence and comments.': 'Live cursors, aanwezigheid en opmerkingen.',
  'Live on the web': 'Live op het web',
  'Load limit': 'Laadlimiet',
  'Load more': 'Meer laden',
  'Loading…': 'Laden…',
  'Local': 'Lokaal',
  'Local universe': 'Lokaal universum',
  'Lock database': 'Database vergrendelen',
  'Lock page': 'Pagina vergrendelen',
  'Locked': 'Vergrendeld',
  'Log in': 'Inloggen',
  'Log out': 'Uitloggen',
  'Log out of all devices': 'Uitloggen op alle apparaten',
  'Log out of all other devices': 'Uitloggen op alle andere apparaten',
  'Logged out of all other devices': 'Uitgelogd op alle andere apparaten',
  'Look Up “{p0}”': '“{p0}” opzoeken',
  'Lowest first': 'Laagste eerst',
  'Lumen': 'Lumen',
  'Lumen Help': 'Lumen-help',
  'Lumen is hosted on our own servers in Amsterdam. Everything travels over HTTPS, access is decided page by page, and there are no analytics, no trackers and no third-party scripts on the pages you write.': 'Lumen draait op onze eigen servers in Amsterdam. Alles gaat via HTTPS, toegang wordt per pagina bepaald, en er zijn geen analytics, geen trackers en geen scripts van derden op de pagina\'s die je schrijft.',
  'Lumen is up to date': 'Lumen is up-to-date',
  'Lumen on GitHub': 'Lumen op GitHub',
  'Lumen {version} is downloading': 'Lumen {version} wordt gedownload',
  'Lumen {version} is ready': 'Lumen {version} staat klaar',
  'Lumen, home': 'Lumen, startpagina',
  'Mac': 'Mac',
  'Mac app': 'Mac-app',
  'Mac app coming soon': 'Mac-app komt binnenkort',
  'Make an account': 'Account aanmaken',
  'Make someone else an owner first.': 'Maak eerst iemand anders eigenaar.',
  'Make someone else an owner of “{workspace}” first, or delete that workspace.': 'Maak eerst iemand anders eigenaar van “{workspace}”, of verwijder die werkruimte.',
  'Make writing stand out.': 'Laat tekst opvallen.',
  'Manual': 'Handmatig',
  'Mara': 'Mara',
  'Mark all as read': 'Alles als gelezen markeren',
  'Mark as code': 'Opmaken als code',
  'Markdown & CSV': 'Markdown & CSV',
  'Markdown & CSV (.zip)': 'Markdown & CSV (.zip)',
  'Markdown shortcuts turn into real blocks as you type, and every action has a keyboard shortcut.': 'Markdown-sneltoetsen worden echte blokken terwijl je typt, en elke actie heeft een sneltoets.',
  'Marketing': 'Marketing',
  'Max': 'Max',
  'MCP server': 'MCP-server',
  'Me': 'Ik',
  'Media': 'Media',
  'Median': 'Mediaan',
  'Medium': 'Middel',
  'Medium section heading.': 'Middelgrote sectiekop.',
  'Meeting notes': 'Vergadernotities',
  'Member': 'Lid',
  'Members': 'Leden',
  'Mention a page': 'Pagina vermelden',
  'Mention a person': 'Persoon vermelden',
  'Mentions': 'Vermeldingen',
  'Mentions and backlinks': 'Vermeldingen en backlinks',
  'Mentions, comments, pages shared with you and reminders, by email.': 'Vermeldingen, opmerkingen, pagina\'s die met je zijn gedeeld en herinneringen, per e-mail.',
  'Mermaid diagrams': 'Mermaid-diagrammen',
  'Message': 'Bericht',
  'Method not allowed': 'Methode niet toegestaan',
  'Min': 'Min',
  'Minimize': 'Minimaliseren',
  'Minimized': 'Geminimaliseerd',
  'Missing CSRF header': 'CSRF-header ontbreekt',
  'Mo': 'ma',
  'Mon': 'ma',
  'Monday': 'maandag',
  'Mono': 'Mono',
  'Month': 'Maand',
  'Month/Day/Year': 'Maand/dag/jaar',
  'Monthly': 'Maandelijks',
  'More': 'Meer',
  'More actions': 'Meer acties',
  'Move block to…': 'Blok verplaatsen naar…',
  'Move blocks to…': 'Blokken verplaatsen naar…',
  'Move down': 'Omlaag verplaatsen',
  'Move page to…': 'Pagina verplaatsen naar…',
  'Move Tab to New Window': 'Tabblad naar nieuw venster verplaatsen',
  'Move the block to another page.': 'Verplaats het blok naar een andere pagina.',
  'Move to': 'Verplaatsen naar',
  'Move to inbox': 'Naar inbox verplaatsen',
  'Move to Trash': 'Naar prullenbak verplaatsen',
  'Move up': 'Omhoog verplaatsen',
  'Moved blocks': 'Blokken verplaatst',
  'Moved to Trash': 'Naar de prullenbak verplaatst',
  'Moved {pages} to Trash': '{pages} naar de prullenbak verplaatst',
  'Multi-select': 'Meervoudige selectie',
  'My account': 'Mijn account',
  'My connections': 'Mijn koppelingen',
  'My notifications': 'Mijn meldingen',
  'My settings': 'Mijn instellingen',
  'Name': 'Naam',
  'Name removed': 'Naam verwijderd',
  'Name this version': 'Deze versie een naam geven',
  'Name updated': 'Naam bijgewerkt',
  'Name, e.g. Claude Code on my laptop': 'Naam, bijv. Claude Code op mijn laptop',
  'Named': 'Met de naam',
  'Named after the page that triggered it': 'Met de naam van de pagina die de automatisering startte',
  'Named versions only': 'Alleen benoemde versies',
  'Never': 'Nooit',
  'never used': 'nooit gebruikt',
  'New': 'Nieuw',
  'New "{p0}" sub-page': 'Nieuwe subpagina "{p0}"',
  'New automation': 'Nieuwe automatisering',
  'New email': 'Nieuw e-mailadres',
  'New equation': 'Nieuwe vergelijking',
  'New Page': 'Nieuwe pagina',
  'New page': 'Nieuwe pagina',
  'New page "': 'Nieuwe pagina "',
  'New password': 'Nieuw wachtwoord',
  'New Tab': 'Nieuw tabblad',
  'New tab': 'Nieuw tabblad',
  'New template': 'Nieuw sjabloon',
  'New to Lumen? ': 'Nieuw bij Lumen? ',
  'New Window': 'Nieuw venster',
  'New workspace': 'Nieuwe werkruimte',
  'Next 30 days': 'Komende 30 dagen',
  'Next 7 days': 'Komende 7 dagen',
  'Next match': 'Volgende overeenkomst',
  'Next month': 'Volgende maand',
  'Next slide': 'Volgende dia',
  'Next up': 'Volgende',
  'No access': 'Geen toegang',
  'No access to this page': 'Geen toegang tot deze pagina',
  'No archived notifications': 'Geen gearchiveerde meldingen',
  'No automations yet. When a page is added or a property changes, or on a schedule, an automation can edit pages, add pages, notify people or send a webhook.': 'Nog geen automatiseringen. Wanneer er een pagina wordt toegevoegd of een eigenschap verandert, of volgens een schema, kan een automatisering pagina\'s bewerken, pagina\'s toevoegen, mensen een melding sturen of een webhook versturen.',
  'No changes since this version.': 'Geen wijzigingen sinds deze versie.',
  'No data to show': 'Geen gegevens om te tonen',
  'No Guesses Found': 'Geen suggesties gevonden',
  'No limit': 'Geen limiet',
  'No matches': 'Geen resultaten',
  'No named versions yet.': 'Nog geen benoemde versies.',
  'No notifications of this type': 'Geen meldingen van dit type',
  'No open comments yet': 'Nog geen open opmerkingen',
  'No pages inside': 'Geen subpagina\'s',
  'No pages to show yet. Create pages and link them with @mentions to see your universe grow.': 'Nog geen pagina\'s om te tonen. Maak pagina\'s en koppel ze met @vermeldingen om je universum te zien groeien.',
  'No recent pages': 'Geen recente pagina\'s',
  'No resolved comments': 'Geen afgehandelde opmerkingen',
  'No results': 'Geen resultaten',
  'No such database': 'Deze database bestaat niet',
  'No tokens yet.': 'Nog geen tokens.',
  'No unread notifications': 'Geen ongelezen meldingen',
  'No updates yet': 'Nog geen updates',
  'No versions yet. Versions are saved automatically as you edit.': 'Nog geen versies. Versies worden automatisch opgeslagen terwijl je bewerkt.',
  'Node size': 'Grootte van knooppunten',
  'None': 'Geen',
  'Not a member': 'Geen lid',
  'Not found': 'Niet gevonden',
  'Not signed in': 'Niet ingelogd',
  'Not started': 'Niet gestart',
  'Not verified yet.': 'Nog niet bevestigd.',
  'Notion': 'Notion',
  'Now': 'Nu',
  'Number': 'Getal',
  'Number format': 'Getalnotatie',
  'Number with commas': 'Getal met scheidingstekens',
  'Numbered list': 'Genummerde lijst',
  'Objects': 'Objecten',
  'of': 'van',
  'Off': 'Uit',
  'Offline': 'Offline',
  'Offline sync': 'Offline synchronisatie',
  'Offline — saved here': 'Offline — hier opgeslagen',
  'Older': 'Ouder',
  'on day': 'op dag',
  'on {weekday}': 'op {weekday}',
  'One click to confirm your email address.': 'Eén klik om je e-mailadres te bevestigen.',
  'One cluster per teamspace': 'Eén cluster per teamruimte',
  'One database, six views': 'Eén database, zes weergaven',
  'One month ago': 'Een maand geleden',
  'One month from now': 'Over een maand',
  'One place. Your documents are not copied to another continent to make a page load faster.': 'Eén plek. Je documenten worden niet naar een ander continent gekopieerd om een pagina sneller te laten laden.',
  'One week ago': 'Een week geleden',
  'One week from now': 'Over een week',
  'One workspace for everything you write, plan and track.': 'Eén werkruimte voor alles wat je schrijft, plant en bijhoudt.',
  'Only people invited': 'Alleen uitgenodigde personen',
  'Only people with edit access can save changes for everyone': 'Alleen mensen met bewerkrechten kunnen wijzigingen voor iedereen opslaan',
  'Only people with full access can answer this.': 'Alleen mensen met volledige toegang kunnen hierop antwoorden.',
  'Only people with full access can change sharing.': 'Alleen mensen met volledige toegang kunnen het delen wijzigen.',
  'Only people with full access to this database can change its automations': 'Alleen mensen met volledige toegang tot deze database kunnen de automatiseringen wijzigen',
  'Only the person who made an automation that sends webhooks can change it': 'Alleen wie een automatisering met webhooks heeft gemaakt, kan die wijzigen',
  'Only this page\'s neighbourhood': 'Alleen de omgeving van deze pagina',
  'Only workspace owners can change workspace settings.': 'Alleen eigenaren van de werkruimte kunnen de instellingen wijzigen.',
  'Only workspace owners can manage members.': 'Alleen eigenaren van de werkruimte kunnen leden beheren.',
  'Only workspace owners can manage the invite link.': 'Alleen eigenaren van de werkruimte kunnen de uitnodigingslink beheren.',
  'OPEN': 'OPENEN',
  'Open': 'Open',
  'Open as full page': 'Openen als volledige pagina',
  'Open in new tab': 'Openen in nieuw tabblad',
  'Open in new window': 'Openen in nieuw venster',
  'Open in Universe': 'Openen in Universe',
  'Open Link in New Tab': 'Link openen in nieuw tabblad',
  'Open Lumen': 'Lumen openen',
  'Open on start': 'Openen bij start',
  'Open page': 'Pagina openen',
  'Open pages in': 'Pagina\'s openen in',
  'Open sidebar': 'Zijbalk openen',
  'Open URL': 'URL openen',
  'Open {workspace}': '{workspace} openen',
  'Open: anyone in the workspace can join': 'Open: iedereen in de werkruimte kan lid worden',
  'Or': 'Of',
  'Orange': 'Oranje',
  'Origin not allowed': 'Herkomst niet toegestaan',
  'Outdent': 'Uitspringen',
  'Owner': 'Eigenaar',
  'Page': 'Pagina',
  'Page added': 'Pagina toegevoegd',
  'Page content': 'Pagina-inhoud',
  'Page cover': 'Paginaomslag',
  'Page discussions': 'Paginadiscussies',
  'Page format': 'Papierformaat',
  'Page is locked': 'Pagina is vergrendeld',
  'Page name': 'Paginanaam',
  'Page not found': 'Pagina niet gevonden',
  'Page updates': 'Pagina-updates',
  'Pages': 'Pagina\'s',
  'Pages in the universe': 'Pagina\'s in het universum',
  'Pages in Trash for over 30 days will be automatically deleted': 'Pagina\'s die langer dan 30 dagen in de prullenbak staan, worden automatisch verwijderd',
  'Pages pull on the pages they link to': 'Pagina\'s trekken aan de pagina\'s waarnaar ze linken',
  'Pages you publish live at /site/{slug}/…': 'Pagina\'s die je publiceert staan op /site/{slug}/…',
  'Pages you visit will show up here.': 'Pagina\'s die je bezoekt, verschijnen hier.',
  'Pages, subpages and databases': 'Pagina\'s, subpagina\'s en databases',
  'Parent item': 'Bovenliggend item',
  'Password': 'Wachtwoord',
  'Password changed': 'Wachtwoord gewijzigd',
  'Password must be at least 8 characters.': 'Je wachtwoord moet minstens 8 tekens hebben.',
  'Paste': 'Plakken',
  'Paste a link…': 'Plak een link…',
  'Paste an image link…': 'Plak een afbeeldingslink…',
  'Paste and Match Style': 'Plakken en stijl aanpassen',
  'Paste in https://…': 'Plak hier https://…',
  'Paste link or search pages': 'Plak een link of zoek pagina\'s',
  'Paste the link…': 'Plak de link…',
  'Pasted as page mention': 'Geplakt als paginavermelding',
  'Pause': 'Pauzeren',
  'Paused': 'Gepauzeerd',
  'Payload too large': 'Het verzoek is te groot',
  'PDF': 'PDF',
  'People': 'Personen',
  'Percent': 'Procent',
  'Percent checked': 'Procent aangevinkt',
  'Percent empty': 'Procent leeg',
  'Percent not empty': 'Procent niet leeg',
  'Percent unchecked': 'Procent niet aangevinkt',
  'Permanently delete my account': 'Mijn account definitief verwijderen',
  'Permanently delete workspace': 'Werkruimte definitief verwijderen',
  'Permissions inherited from': 'Rechten overgenomen van',
  'Person': 'Persoon',
  'Person who clicked': 'Persoon die heeft geklikt',
  'Person who triggered it': 'Persoon die de automatisering startte',
  'Phone': 'Telefoon',
  'Photo': 'Foto',
  'Photo updated': 'Foto bijgewerkt',
  'Pin Tab': 'Tabblad vastzetten',
  'Ping someone so they get a notification.': 'Stuur iemand een seintje, zodat die een melding krijgt.',
  'Pink': 'Roze',
  'Plain text': 'Platte tekst',
  'Play': 'Afspelen',
  'Please confirm that {email} is your email address, so Lumen can send you invites, notifications and password resets.': 'Bevestig dat {email} jouw e-mailadres is, zodat Lumen je uitnodigingen, meldingen en links om je wachtwoord te herstellen kan sturen.',
  'Please enter a domain.': 'Vul een domein in.',
  'Please enter a name.': 'Vul een naam in.',
  'Please enter a number': 'Voer een getal in',
  'Please enter a valid email address.': 'Vul een geldig e-mailadres in.',
  'Pound': 'Pond',
  'Preferred name': 'Voorkeursnaam',
  'Prefix': 'Voorvoegsel',
  'Present': 'Presenteren',
  'Press /': 'Druk op /',
  'Press Enter and type. “/” opens the block menu, Markdown shortcuts turn into real blocks, and Mod+K finds any page.': 'Druk op Enter en typ. “/” opent het blokmenu, Markdown-sneltoetsen worden echte blokken en met Mod+K vind je elke pagina.',
  'Press Enter to continue with an empty page, or pick a template': 'Druk op Enter om verder te gaan met een lege pagina, of kies een sjabloon',
  'Preview image URL': 'URL van voorbeeldafbeelding',
  'Previous 30 days': 'Afgelopen 30 dagen',
  'Previous 7 days': 'Afgelopen 7 dagen',
  'Previous match': 'Vorige overeenkomst',
  'Previous month': 'Vorige maand',
  'Previous slide': 'Vorige dia',
  'Private': 'Privé',
  'Private pages': 'Privépagina\'s',
  'Private: only members can see this teamspace': 'Privé: alleen leden zien deze teamruimte',
  'Product roadmap': 'Productroadmap',
  'Project tracker': 'Projecttracker',
  'Properties': 'Eigenschappen',
  'Property': 'Eigenschap',
  'Property edited': 'Eigenschap bewerkt',
  'Publish': 'Publiceren',
  'Publish to a public link': 'Publiceren via een openbare link',
  'Publish to web': 'Publiceren op het web',
  'Purple': 'Paars',
  'Quarter': 'Kwartaal',
  'Quick find searches titles and page text across the whole workspace, including pages you have never opened on this device.': 'Snel zoeken doorzoekt titels en paginatekst in de hele werkruimte, ook pagina\'s die je op dit apparaat nog nooit hebt geopend.',
  'Quit Lumen': 'Lumen stoppen',
  'Quote': 'Citaat',
  'Random': 'Willekeurig',
  'Range': 'Bereik',
  'Re-open': 'Heropenen',
  'Real': 'Real',
  'Real-time sync': 'Realtime synchronisatie',
  'Recent': 'Recent',
  'Recently visited': 'Recent bezocht',
  'Recommended size is 280 × 280 pixels': 'Aanbevolen formaat is 280 × 280 pixels',
  'Reconnecting…': 'Opnieuw verbinden…',
  'Recorded end to end in the actual app: writing, markdown shortcuts, the slash menu, a database in three views, two people in one page, and quick find. Captions only, no sound.': 'Van begin tot eind opgenomen in de echte app: schrijven, Markdown-sneltoetsen, het slash-menu, een database in drie weergaven, twee mensen op één pagina en snel zoeken. Alleen ondertiteling, geen geluid.',
  'Red': 'Rood',
  'Redo': 'Opnieuw',
  'Related to': 'Gerelateerd aan',
  'Relation': 'Relatie',
  'Relative': 'Relatief',
  'Reload': 'Opnieuw laden',
  'Remind': 'Herinnering',
  'Remind me': 'Herinner me',
  'Reminder': 'Herinnering',
  'Reminder in {title}': 'Herinnering in {title}',
  'Reminder: {title}': 'Herinnering: {title}',
  'Reminders': 'Herinneringen',
  'Reminders, notifications and emails are delivered based on your time zone.': 'Herinneringen, meldingen en e-mails worden verstuurd op basis van je tijdzone.',
  'Remove': 'Verwijderen',
  'Remove action': 'Actie verwijderen',
  'Remove file': 'Bestand verwijderen',
  'Remove formatting': 'Opmaak wissen',
  'Remove from Favorites': 'Verwijderen uit favorieten',
  'Remove from teamspace': 'Verwijderen uit teamruimte',
  'Remove header': 'Header verwijderen',
  'Remove link': 'Link verwijderen',
  'Remove rule': 'Regel verwijderen',
  'Remove sort': 'Sortering verwijderen',
  'Remove sorts to reorder rows manually': 'Verwijder de sorteringen om rijen handmatig te ordenen',
  'Remove trigger': 'Trigger verwijderen',
  'Remove value': 'Waarde verwijderen',
  'Remove {name}': '{name} verwijderen',
  'Remove {name} from {name1}?': '{name} verwijderen uit {name1}?',
  'Removes your account, your private pages and the workspaces only you are in. This cannot be undone.': 'Verwijdert je account, je privépagina\'s en de werkruimtes waarvan alleen jij lid bent. Dit kan niet ongedaan worden gemaakt.',
  'Rename': 'Naam wijzigen',
  'Reopen Closed Tab': 'Gesloten tabblad opnieuw openen',
  'Repeat': 'Herhalen',
  'Repel': 'Afstoting',
  'Replace': 'Vervangen',
  'Reply in Lumen': 'Antwoorden in Lumen',
  'Reply…': 'Antwoorden…',
  'Reposition': 'Positie wijzigen',
  'Request access': 'Toegang aanvragen',
  'Request sent. You\'ll get a notification when someone with full access shares the page with you.': 'Verzoek verstuurd. Je krijgt een melding zodra iemand met volledige toegang de pagina met je deelt.',
  'Research notes': 'Onderzoeksnotities',
  'Reset': 'Opnieuw instellen',
  'Reset your Lumen password': 'Herstel je Lumen-wachtwoord',
  'Reset your password': 'Wachtwoord opnieuw instellen',
  'Resolve': 'Afhandelen',
  'Resolved': 'Afgehandeld',
  'Restart Lumen to finish updating.': 'Start Lumen opnieuw om de update af te ronden.',
  'Restart to update': 'Herstart om bij te werken',
  'Restore': 'Terugzetten',
  'Restore inherited permissions': 'Overgenomen rechten terugzetten',
  'Restore page': 'Pagina terugzetten',
  'Restored {p0}': '{p0} teruggezet',
  'Results': 'Resultaten',
  'Reverse alphabetical': 'Omgekeerd alfabetisch',
  'review — Marketing': 'review — Marketing',
  'Revoke': 'Intrekken',
  'Revoked “{name}”': '“{name}” ingetrokken',
  'Ring': 'Ring',
  'Roadmap': 'Roadmap',
  'roadmap': 'roadmap',
  'Role': 'Rol',
  'Rollup': 'Rollup',
  'Row': 'Rij',
  'Row options': 'Rijopties',
  'Ruble': 'Roebel',
  'Runs': 'Uitvoeringen',
  'Rupee': 'Roepie',
  'Sa': 'za',
  'Sat': 'za',
  'Saturday': 'zaterdag',
  'Save': 'Opslaan',
  'Save a link as a visual bookmark.': 'Bewaar een link als visuele bladwijzer.',
  'Save for everyone': 'Opslaan voor iedereen',
  'Save position': 'Positie opslaan',
  'Save version': 'Versie opslaan',
  'Search': 'Zoeken',
  'Search actions…': 'Acties zoeken…',
  'Search engine indexing': 'Indexering door zoekmachines',
  'Search engines and link previews': 'Zoekmachines en linkvoorbeelden',
  'Search for a database…': 'Zoek een database…',
  'Search for a language…': 'Zoek een taal…',
  'Search for a property type…': 'Zoek een eigenschapstype…',
  'Search for an emoji to place in text.': 'Zoek een emoji om in tekst te plaatsen.',
  'Search for an option…': 'Zoek een optie…',
  'Search for people…': 'Zoek personen…',
  'Search in this database': 'Zoeken in deze database',
  'Search pages in Trash': 'Pagina\'s in de prullenbak zoeken',
  'Search pages…': 'Pagina\'s zoeken…',
  'Search with Google': 'Zoeken met Google',
  'Search {name}…': 'Zoeken in {name}…',
  'Sections': 'Secties',
  'See it': 'Bekijken',
  'Select': 'Selectie',
  'Select a database': 'Selecteer een database',
  'Select a page': 'Selecteer een pagina',
  'Select a person': 'Selecteer een persoon',
  'Select a property': 'Selecteer een eigenschap',
  'Select a relation': 'Selecteer een relatie',
  'Select a status': 'Selecteer een status',
  'Select All': 'Alles selecteren',
  'Select all': 'Alles selecteren',
  'Select an option or create one': 'Selecteer een optie of maak er een',
  'Select row': 'Rij selecteren',
  'Select skin tone': 'Huidskleur kiezen',
  'Send': 'Versturen',
  'Send notification': 'Melding sturen',
  'Send notification to': 'Melding sturen naar',
  'Send reset link': 'Resetlink versturen',
  'Send the link again': 'Link opnieuw versturen',
  'Send webhook': 'Webhook versturen',
  'Sends the page\'s name and these properties to the address above:': 'Stuurt de naam van de pagina en deze eigenschappen naar het adres hierboven:',
  'Sent by Lumen to {email}': 'Verstuurd door Lumen aan {email}',
  'Serif': 'Serif',
  'Services': 'Voorzieningen',
  'Set': 'Instellen',
  'Set as default for all views': 'Instellen als standaard voor alle weergaven',
  'Set as default for {name}': 'Instellen als standaard voor {name}',
  'Set password and log in': 'Wachtwoord instellen en inloggen',
  'Set timezone automatically': 'Tijdzone automatisch instellen',
  'Set timezone automatically using your location': 'Tijdzone automatisch instellen op basis van je locatie',
  'Settings': 'Instellingen',
  'Settings sections': 'Onderdelen van instellingen',
  'Settings…': 'Instellingen…',
  'Share': 'Delen',
  'Shared': 'Gedeeld',
  'Shared on purpose': 'Bewust gedeeld',
  'Shared with you': 'Met jou gedeeld',
  'Shift + Enter for a new line': 'Shift + Enter voor een nieuwe regel',
  'Ship on Friday': 'Vrijdag uitbrengen',
  'Show': 'Tonen',
  'Show a view of an existing database.': 'Toon een weergave van een bestaande database.',
  'Show All': 'Alles tonen',
  'Show all': 'Alles tonen',
  'Show an outline of your page.': 'Toon een overzicht van je pagina.',
  'Show as': 'Tonen als',
  'Show calendar by': 'Kalender tonen op basis van',
  'Show confirmation': 'Bevestiging tonen',
  'Show filters': 'Filters tonen',
  'Show in popover': 'Tonen in pop-up',
  'Show Next Tab': 'Volgend tabblad tonen',
  'Show on {p0}': 'Tonen in {p0}',
  'Show original': 'Origineel tonen',
  'Show pages in sidebar': 'Pagina\'s tonen in zijbalk',
  'Show Previous Tab': 'Vorig tabblad tonen',
  'Show sub-items': 'Subitems tonen',
  'Show table': 'Tabel tonen',
  'Show the location of this page.': 'Toon de locatie van deze pagina.',
  'Show the number of unread notifications next to Inbox.': 'Toon het aantal ongelezen meldingen naast Inbox.',
  'Show timeline by': 'Tijdlijn tonen op basis van',
  'Show unique values': 'Unieke waarden tonen',
  'Show weekends': 'Weekenden tonen',
  'Show {label}': '{label} tonen',
  'Show {name}': '{name} tonen',
  'Shown in': 'Zichtbaar in',
  'Shown next to your name in comments, mentions and presence.': 'Wordt naast je naam getoond bij opmerkingen, vermeldingen en aanwezigheid.',
  'Side peek': 'Zijvenster',
  'Sign in': 'Inloggen',
  'Sign-up is by invitation only. Ask a workspace owner to invite you.': 'Aanmelden kan alleen op uitnodiging. Vraag een eigenaar van een werkruimte om je uit te nodigen.',
  'Sign-up is by invitation only. Use the email address you were invited with.': 'Je kunt alleen een account aanmaken als je bent uitgenodigd. Gebruik het e-mailadres waarmee je bent uitgenodigd.',
  'Sign-up is limited to {domains} addresses. Ask a workspace owner to invite you.': 'Aanmelden kan alleen met een {domains}-adres. Vraag een eigenaar van een werkruimte om je uit te nodigen.',
  'Sign-up is open to {domains} addresses, and to people who were invited.': 'Je kunt een account aanmaken met een e-mailadres van {domains}, of als je bent uitgenodigd.',
  'Signs you out everywhere, including this browser.': 'Logt je overal uit, ook in deze browser.',
  'Signs you out on this device only. Your other devices stay signed in.': 'Logt je alleen op dit apparaat uit. Op je andere apparaten blijf je ingelogd.',
  'Skip to content': 'Naar de inhoud gaan',
  'Slices': 'Segmenten',
  'Small': 'Klein',
  'Small section heading.': 'Kleine sectiekop.',
  'Small text': 'Kleine tekst',
  'Someone': 'Iemand',
  'Someone (hopefully you) asked to reset the password of your Lumen account. Choose a new one with the button below.': 'Iemand (hopelijk jij) heeft gevraagd het wachtwoord van je Lumen-account te herstellen. Kies een nieuw wachtwoord met de knop hieronder.',
  'Something went wrong': 'Er is iets misgegaan',
  'Something went wrong. Check your connection and try again.': 'Er is iets misgegaan. Controleer je verbinding en probeer het opnieuw.',
  'Sort': 'Sorteren',
  'Sort ascending': 'Oplopend sorteren',
  'Sort by…': 'Sorteren op…',
  'Sort descending': 'Aflopend sorteren',
  'Sound off': 'Geluid uit',
  'Sound on': 'Geluid aan',
  'Start a page.': 'Begin een pagina.',
  'Start Speaking': 'Start met spreken',
  'Start week on Monday': 'Week op maandag laten beginnen',
  'Starting': 'Vanaf',
  'Starts with': 'Begint met',
  'Status': 'Status',
  'Stop Speaking': 'Stop met spreken',
  'Streamable HTTP, with the token as a bearer header.': 'Streamable HTTP, met het token als bearer-header.',
  'Strike-through': 'Doorhalen',
  'Strikethrough': 'Doorhalen',
  'Style': 'Stijl',
  'Style, export, and more…': 'Stijl, exporteren en meer…',
  'Su': 'zo',
  'Sub-group': 'Subgroep',
  'Sub-items': 'Subitems',
  'Submit': 'Verzenden',
  'Subpage lines': 'Lijnen naar subpagina\'s',
  'Sum': 'Som',
  'Sun': 'zo',
  'Sunday': 'zondag',
  'Symbols': 'Symbolen',
  'Sync content across multiple pages.': 'Synchroniseer inhoud tussen meerdere pagina\'s.',
  'Synced block': 'Gesynchroniseerd blok',
  'Synced everywhere, even when you are not': 'Overal gesynchroniseerd, ook als jij offline bent',
  'Synced to every device': 'Gesynchroniseerd met elk apparaat',
  'Table': 'Tabel',
  'Table - Full page': 'Tabel - volledige pagina',
  'Table of contents': 'Inhoudsopgave',
  'Table options': 'Tabelopties',
  'Table view': 'Tabelweergave',
  'Table, board, list, gallery, calendar and timeline over the same rows — each with its own filters, sorts, groups and calculations.': 'Tabel, bord, lijst, galerij, kalender en tijdlijn op dezelfde rijen — elk met eigen filters, sorteringen, groepen en berekeningen.',
  'Tabs': 'Tabbladen',
  'Tags': 'Tags',
  'Tasks': 'Taken',
  'Teamspace': 'Teamruimte',
  'Teamspace members and people invited': 'Leden van de teamruimte en uitgenodigde personen',
  'Teamspace owner': 'Eigenaar van teamruimte',
  'Teamspace settings': 'Teamruimte-instellingen',
  'Teamspace settings and more': 'Teamruimte-instellingen en meer',
  'Teamspace: {p0}': 'Teamruimte: {p0}',
  'Teamspaces': 'Teamruimten',
  'Teamspaces are where your team organizes pages, permissions, and members.': 'In teamruimtes organiseert je team pagina\'s, rechten en leden.',
  'Template options': 'Sjabloonopties',
  'Templates': 'Sjablonen',
  'Templates for': 'Sjablonen voor',
  'TestFlight': 'TestFlight',
  'Text': 'Tekst',
  'Text & Markdown': 'Tekst & Markdown',
  'Th': 'do',
  'That would make a loop: it already waits for this one.': 'Dat zou een lus opleveren: die wacht al op deze.',
  'The browser app is the whole product today, and it installs to your dock or home screen. Native shells are next.': 'De browserapp is vandaag het hele product, en je installeert hem in je Dock of op je beginscherm. Native apps komen hierna.',
  'The link works for 7 days.': 'De link werkt 7 dagen.',
  'The link works once, for one hour.': 'De link werkt één keer, een uur lang.',
  'The Lumen editor assembling a page called Product roadmap: to-dos, a callout and a database table, with a second person\'s cursor.': 'De Lumen-editor bouwt een pagina op met de naam Productroadmap: taken, een kader en een databasetabel, met de cursor van een tweede persoon.',
  'The maximum size per file is 50 MB.': 'De maximale grootte per bestand is 50 MB.',
  'The next month': 'Komende maand',
  'The next week': 'Komende week',
  'The next year': 'Komend jaar',
  'The notification could not be sent.': 'De melding kon niet worden verstuurd.',
  'The page cover': 'De omslag van de pagina',
  'The page that triggered it': 'De pagina die de automatisering startte',
  'The past month': 'Afgelopen maand',
  'The past week': 'Afgelopen week',
  'The past year': 'Afgelopen jaar',
  'The request could not be sent.': 'Het verzoek kon niet worden verstuurd.',
  'The same pages on a phone, in sync with everything else. The beta goes out through TestFlight first.': 'Dezelfde pagina\'s op je telefoon, gesynchroniseerd met al het andere. De bèta verschijnt eerst via TestFlight.',
  'The start of the page': 'Het begin van de pagina',
  'This database no longer exists.': 'Deze database bestaat niet meer.',
  'This device': 'Dit apparaat',
  'This domain is already taken.': 'Dit domein is al in gebruik.',
  'This invite link is no longer valid. Ask for a new one.': 'Deze uitnodigingslink is niet meer geldig. Vraag een nieuwe aan.',
  'This link has expired or was already used.': 'Deze link is verlopen of al gebruikt.',
  'This link has expired or was already used. Ask for a new one.': 'Deze link is verlopen of al gebruikt. Vraag een nieuwe aan.',
  'This page': 'Deze pagina',
  'This page does not exist': 'Deze pagina bestaat niet',
  'This page is already public through': 'Deze pagina is al openbaar via',
  'This page is in Trash.': 'Deze pagina staat in de prullenbak.',
  'This page may have been unpublished, or its link has expired.': 'Deze pagina is misschien niet meer gepubliceerd, of de link is verlopen.',
  'This quarter': 'Dit kwartaal',
  'This request was already answered.': 'Dit verzoek is al beantwoord.',
  'This server can\'t send email yet. Ask the person who runs your Lumen to reset your password.': 'Deze server kan nog geen e-mail versturen. Vraag degene die jullie Lumen beheert om je wachtwoord opnieuw in te stellen.',
  'This server cannot send email yet.': 'Deze server kan nog geen e-mail versturen.',
  'This will change how all calendars in your app look.': 'Dit verandert hoe alle kalenders in de app eruitzien.',
  'Three slices, one owner each. The board view groups by': 'Drie onderdelen, elk met één eigenaar. De bordweergave groepeert op',
  'Thu': 'do',
  'Thursday': 'donderdag',
  'Time format': 'Tijdnotatie',
  'Time zone': 'Tijdzone',
  'Timelapse': 'Timelapse',
  'Timeline': 'Tijdlijn',
  'Timeline - Full page': 'Tijdlijn - volledige pagina',
  'Timeline view': 'Tijdlijnweergave',
  'Title': 'Titel',
  'Title only': 'Alleen titel',
  'To-do': 'Te doen',
  'To-do list': 'Takenlijst',
  'Today': 'Vandaag',
  'Toggle': 'Uitklapblok',
  'Toggle Dark Mode': 'Donkere modus aan of uit',
  'Toggle Developer Tools': 'Ontwikkelaarstools tonen of verbergen',
  'Toggle Full Screen': 'Volledig scherm aan of uit',
  'Toggle heading 1': 'Uitklapbare kop 1',
  'Toggle heading 2': 'Uitklapbare kop 2',
  'Toggle heading 3': 'Uitklapbare kop 3',
  'Toggle list': 'Uitklaplijst',
  'Toggle Sidebar': 'Zijbalk tonen of verbergen',
  'Toggles can hide and show content inside.': 'Met uitklapblokken kun je inhoud verbergen en tonen.',
  'Token': 'Token',
  'Token name': 'Tokennaam',
  'Tomorrow': 'Morgen',
  'Too many attempts. Try again in a minute.': 'Te veel pogingen. Probeer het over een minuut opnieuw.',
  'Too many attempts. Try again in {minutes} minutes.': 'Te veel pogingen. Probeer het over {minutes} minuten opnieuw.',
  'Too many notifications. Try again in a minute.': 'Te veel meldingen. Probeer het over een minuut opnieuw.',
  'Too many requests. Try again later.': 'Te veel verzoeken. Probeer het later opnieuw.',
  'Track tasks with a to-do list.': 'Houd taken bij met een takenlijst.',
  'Trash': 'Prullenbak',
  'Trash for 30 days': 'Prullenbak met 30 dagen bewaartijd',
  'Trash is empty': 'De prullenbak is leeg',
  'Tu': 'di',
  'Tue': 'di',
  'Tuesday': 'dinsdag',
  'Turn into': 'Omzetten naar',
  'Turn into inline': 'Omzetten in inline database',
  'Turn into page': 'Omzetten in pagina',
  'Turn into page in': 'Omzetten naar pagina in',
  'Turn into page in…': 'Omzetten naar pagina in…',
  'Turn into {label}': 'Omzetten naar {label}',
  'Turn off': 'Uitschakelen',
  'Type': 'Type',
  'Type a formula, e.g. prop("Price") * 2': 'Typ een formule, bijv. prop("Prijs") * 2',
  'Type a prefix': 'Typ een voorvoegsel',
  'Type a value…': 'Typ een waarde…',
  'Type instead of clicking': 'Typen in plaats van klikken',
  'Type the workspace name to confirm.': 'Typ de naam van de werkruimte om te bevestigen.',
  'Type to search…': 'Typ om te zoeken…',
  'Type “': 'Typ “',
  'Unchecked': 'Niet aangevinkt',
  'Unconnected pages': 'Niet-verbonden pagina\'s',
  'Underline': 'Onderstrepen',
  'Undo': 'Ongedaan maken',
  'Unfreeze columns': 'Kolommen losmaken',
  'Universe': 'Universum',
  'Universe: {length} pages and {length1} connections. Use + and − to zoom, arrows to move, 0 to fit.': 'Universum: {length} pagina\'s en {length1} verbindingen. Gebruik + en − om te zoomen, de pijltjestoetsen om te verplaatsen en 0 om passend te maken.',
  'Unknown': 'Onbekend',
  'Unknown access level': 'Onbekend toegangsniveau',
  'Unknown action': 'Onbekende actie',
  'Unknown kind': 'Onbekend soort',
  'Unknown user': 'Onbekende gebruiker',
  'Unlock database': 'Database ontgrendelen',
  'Unpin Tab': 'Tabblad losmaken',
  'Unpublish': 'Publicatie intrekken',
  'Unread': 'Ongelezen',
  'Unread count': 'Aantal ongelezen',
  'Unread count in the sidebar': 'Aantal ongelezen in de zijbalk',
  'Unsync': 'Synchronisatie opheffen',
  'Unsynced. These blocks are now independent': 'Synchronisatie opgeheven. Deze blokken zijn nu onafhankelijk',
  'Untitled': 'Naamloos',
  'Untitled workspace': 'Naamloze werkruimte',
  'Unwrap code': 'Code niet laten teruglopen',
  'Update': 'Bijwerken',
  'Updates': 'Updates',
  'Updates are off in this build': 'Updates staan uit in deze versie',
  'Updating… {percent}%': 'Bijwerken… {percent}%',
  'Upload': 'Uploaden',
  'Upload a file': 'Bestand uploaden',
  'Upload an image': 'Afbeelding uploaden',
  'Upload an image or pick an emoji. It shows in your sidebar.': 'Upload een afbeelding of kies een emoji. Die verschijnt in je zijbalk.',
  'Upload file': 'Bestand uploaden',
  'Upload or embed with a link.': 'Upload of sluit in met een link.',
  'Upload photo': 'Foto uploaden',
  'Uploading…': 'Uploaden…',
  'URL': 'URL',
  'US dollar': 'Amerikaanse dollar',
  'Use system setting': 'Systeeminstelling gebruiken',
  'Use this template': 'Dit sjabloon gebruiken',
  'User': 'Gebruiker',
  'Value': 'Waarde',
  'Verification email sent': 'Bevestigingsmail verstuurd',
  'Verify your email for Lumen': 'Bevestig je e-mailadres voor Lumen',
  'Verifying…': 'Bevestigen…',
  'Version': 'Versie',
  'Version history': 'Versiegeschiedenis',
  'Version history and restore': 'Versiegeschiedenis en terugzetten',
  'Version named': 'Versie benoemd',
  'Version restored': 'Versie teruggezet',
  'Version saved': 'Versie opgeslagen',
  'Version {version}': 'Versie {version}',
  'Video': 'Video',
  'View': 'Weergave',
  'View all comments': 'Alle opmerkingen bekijken',
  'View all updates': 'Alle updates bekijken',
  'View options': 'Weergaveopties',
  'View settings': 'Weergave-instellingen',
  'View site': 'Site bekijken',
  'Views': 'Weergaven',
  'Visually divide blocks.': 'Deel blokken visueel op.',
  'We': 'wo',
  'We\'ll email you a link to choose a new one.': 'We sturen je een link waarmee je een nieuw wachtwoord kiest.',
  'Web': 'Web',
  'Web bookmark': 'Webbladwijzer',
  'Wed': 'wo',
  'Wednesday': 'woensdag',
  'Week': 'Week',
  'Week of {date}': 'Week van {date}',
  'Weekly': 'Wekelijks',
  'Weekly review': 'Weekoverzicht',
  'Welcome back to your workspace.': 'Welkom terug in je werkruimte.',
  'What to color': 'Wat kleuren',
  'When': 'Wanneer',
  'When all of these happen': 'Wanneer deze allemaal gebeuren',
  'When any of these happen': 'Wanneer een hiervan gebeurt',
  'When pages were created': 'Wanneer pagina\'s zijn aangemaakt',
  'Where': 'Waar',
  'Where you\'re signed in. Sessions end after 60 days without use.': 'Waar je bent ingelogd. Sessies verlopen na 60 dagen zonder gebruik.',
  'Window': 'Venster',
  'Won': 'Won',
  'Word count:': 'Aantal woorden:',
  'Workspace': 'Werkruimte',
  'Workspace name': 'Naam van werkruimte',
  'Workspace owner': 'Eigenaar van werkruimte',
  'Workspace renamed': 'Naam van werkruimte gewijzigd',
  'Workspace settings': 'Werkruimte-instellingen',
  'Wrap all columns': 'Tekst in alle kolommen laten teruglopen',
  'Wrap code': 'Code laten teruglopen',
  'Wrap column': 'Kolom laten teruglopen',
  'Write': 'Schrijven',
  'Write a caption…': 'Schrijf een bijschrift…',
  'Write something, or press \'/\' for commands…': 'Schrijf iets, of typ \'/\' voor opdrachten…',
  'Write the migration guide': 'De migratiegids schrijven',
  'Write together': 'Samen schrijven',
  'X axis': 'X-as',
  'x^2': 'x^2',
  'Y axis': 'Y-as',
  'Year': 'Jaar',
  'Year/Month/Day': 'Jaar/maand/dag',
  'Yearly': 'Jaarlijks',
  'Yellow': 'Geel',
  'Yen': 'Yen',
  'Yesterday': 'Gisteren',
  'You are not a member of any workspace.': 'Je bent geen lid van een werkruimte.',
  'You are now a guest of the workspace “{workspace}”. It shows up in your workspace switcher.': 'Je bent nu gast in de werkruimte “{workspace}”. Je vindt hem in je werkruimtekiezer.',
  'You are now a member of the workspace “{workspace}”. It shows up in your workspace switcher.': 'Je bent nu lid van de werkruimte “{workspace}”. Je vindt hem in je werkruimtekiezer.',
  'You are now an owner of the workspace “{workspace}”. It shows up in your workspace switcher.': 'Je bent nu eigenaar van de werkruimte “{workspace}”. Je vindt hem in je werkruimtekiezer.',
  'You can now open {workspace} in Lumen.': 'Je kunt {workspace} nu openen in Lumen.',
  'You can use your organization or company name.': 'Je kunt de naam van je organisatie of bedrijf gebruiken.',
  'You cannot remove yourself.': 'Je kunt jezelf niet verwijderen.',
  'You get these emails because email notifications are on. Turn them off in Settings → My notifications.': 'Je krijgt deze e-mails omdat e-mailmeldingen aanstaan. Zet ze uit via Instellingen → Mijn meldingen.',
  'You get this email because email notifications are on. Turn them off in Settings → My notifications.': 'Je krijgt deze e-mail omdat e-mailmeldingen aanstaan. Zet ze uit via Instellingen → Mijn meldingen.',
  'You have': 'Jouw toegang:',
  'You have 25 tokens. Revoke one first.': 'Je hebt al 25 tokens. Trek er eerst een in.',
  'You lose access to its pages. Your private pages in it are deleted.': 'Je verliest de toegang tot de pagina\'s erin. Je privépagina\'s erin worden verwijderd.',
  'You need edit access to every database an automation writes to': 'Je hebt bewerktoegang nodig tot elke database waarin een automatisering schrijft',
  'You\'re all caught up': 'Je bent helemaal bij',
  'You\'re its only member: delete the workspace instead.': 'Je bent het enige lid: verwijder de werkruimte in plaats daarvan.',
  'You\'re offline. Changes are saved on this device and will sync when you reconnect.': 'Je bent offline. Wijzigingen worden op dit apparaat opgeslagen en gesynchroniseerd zodra je weer verbinding hebt.',
  'Your changes to this view are only visible to you.': 'Je wijzigingen in deze weergave zijn alleen voor jou zichtbaar.',
  'Your current password is incorrect.': 'Je huidige wachtwoord klopt niet.',
  'Your ideas, docs and projects. Together.': 'Je ideeën, documenten en projecten. Samen.',
  'Your page tree as orbits around the centre': 'Je paginastructuur als banen rond het midden',
  'Your pages live in the EU': 'Je pagina\'s staan in de EU',
  'Your password is incorrect.': 'Je wachtwoord klopt niet.',
  'Your workspace is one click away, and it will be there on every device you open it on.': 'Je werkruimte is één klik verwijderd, en staat klaar op elk apparaat waarop je hem opent.',
  'Yours to take': 'Neem alles mee',
  'Yuan': 'Yuan',
  'Zoom': 'Zoomen',
  'Zoom In': 'Inzoomen',
  'Zoom in': 'Inzoomen',
  'Zoom Out': 'Uitzoomen',
  'Zoom out': 'Uitzoomen',
  '{calc} of {property}': '{calc} van {property}',
  '{color} background': 'Achtergrond: {color}',
  '{email} is confirmed. Thanks!': '{email} is bevestigd. Bedankt!',
  '{inviter} added you to {workspace}': '{inviter} heeft je toegevoegd aan {workspace}',
  '{inviter} invited you to a page': '{inviter} heeft je uitgenodigd voor een pagina',
  '{inviter} invited you to the workspace “{workspace}”, where your team writes, plans and organizes together.': '{inviter} heeft je uitgenodigd voor de werkruimte “{workspace}”, waar je team samen schrijft, plant en organiseert.',
  '{inviter} invited you to {target}': '{inviter} heeft je uitgenodigd voor {target}',
  '{inviter} shared a page in “{workspace}” with you.': '{inviter} heeft een pagina in “{workspace}” met je gedeeld.',
  '{label} done': '{label} uitgevoerd',
  '{length} sorts': '{length} sorteringen',
  '{measure} by {property}': '{measure} per {property}',
  '{name} is here. Jump to their cursor': '{name} is hier. Ga naar de cursor',
  '{name}\'s Lumen': 'Lumen van {name}',
  '{n} backlink': '{n} backlink',
  '{n} backlinks': '{n} backlinks',
  '{n} columns': '{n} kolommen',
  '{n} database': '{n} database',
  '{n} databases': '{n} databases',
  '{n} days': '{n} dagen',
  '{n} days ago': '{n} dagen geleden',
  '{n} file': '{n} bestand',
  '{n} files': '{n} bestanden',
  '{n} hour ago': '{n} uur geleden',
  '{n} hours ago': '{n} uur geleden',
  '{n} minute ago': '{n} minuut geleden',
  '{n} minutes ago': '{n} minuten geleden',
  '{n} more properties': 'Nog {n} eigenschappen',
  '{n} more property': 'Nog {n} eigenschap',
  '{n} page': '{n} pagina',
  '{n} pages': '{n} pagina\'s',
  '{n} rule': '{n} regel',
  '{n} rules': '{n} regels',
  '{n} selected': '{n} geselecteerd',
  '{n} shown': '{n} zichtbaar',
  '{p0} (this database)': '{p0} (deze database)',
  '{p0} added · {p1} removed · {p2} changed since this version': '{p0} toegevoegd · {p1} verwijderd · {p2} gewijzigd sinds deze versie',
  '{p0} done': '{p0} uitgevoerd',
  '{p0} invited you to {name} on Lumen.': '{p0} heeft je uitgenodigd voor {name} op Lumen.',
  '{property} is': '{property} is',
  '{what} copied': '{what} gekopieerd',
  '{what} in {p1}': '{what} in {p1}',
  '{who} added you': '{who} heeft je toegevoegd',
  '{who} added you as {role}': '{who} heeft je toegevoegd als {role}',
  '{who} added you as {role} in {title}': '{who} heeft je als {role} toegevoegd in {title}',
  '{who} added you in {title}': '{who} heeft je toegevoegd in {title}',
  '{who} added you to {title}': '{who} heeft je toegevoegd aan {title}',
  '{who} asks for access': '{who} vraagt om toegang',
  '{who} commented': '{who} heeft een opmerking geplaatst',
  '{who} commented in {title}': '{who} heeft een opmerking geplaatst in {title}',
  '{who} edited {title}': '{who} heeft {title} bewerkt',
  '{who} invited you': '{who} heeft je uitgenodigd',
  '{who} invited you to {title}': '{who} heeft je uitgenodigd voor {title}',
  '{who} mentioned you': '{who} heeft je vermeld',
  '{who} mentioned you in {title}': '{who} heeft je vermeld in {title}',
  '{who} notified you': '{who} heeft je een melding gestuurd',
  '{who} notified you in {title}': '{who} heeft je een melding gestuurd in {title}',
  '{who} requests access to {title}': '{who} vraagt toegang tot {title}',
  '{who} requests edit access': '{who} vraagt bewerktoegang',
  '{who} requests edit access to {title}': '{who} vraagt toegang om {title} te bewerken',
  '{who} requests view access': '{who} vraagt leestoegang',
  '{who} requests view access to {title}': '{who} vraagt toegang om {title} te bekijken',
  '{who} sent you a notification': '{who} heeft je een melding gestuurd',
  '{who} shared a page with you': '{who} heeft een pagina met je gedeeld',
  '{who} shared {title} with you': '{who} heeft {title} met je gedeeld',
  '· created': '· aangemaakt',
  '· Remove': '· Verwijderen',
  '— Private': '— Privé',
  '” to confirm.': '” om te bevestigen.',
  '↑↓ Select': '↑↓ Selecteren',
  '↵ Open': '↵ Openen',
  '🚀 Product roadmap': '🚀 Productroadmap',
};
